export * as leased from './leased'
export * as owned from './owned'
